import useTranslation from "next-translate/useTranslation";
import { HomeMetricCardV2 as DashboardCard } from "components/ui/v2";

interface IKPIOrgCareersProps {
  loading?: boolean;
  achievedInTime: [number, number];
  accomplishedOutOfTime: [number, number];
  notAchieved: [number, number];
  performance: number;
}

const KPIOrgCareers = (props: IKPIOrgCareersProps) => {
  const {
    achievedInTime,
    accomplishedOutOfTime,
    notAchieved,
    performance,
    loading,
  } = props;
  const { t } = useTranslation("common");

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
      <DashboardCard
        title={t("Objetivos logrados en tiempo")}
        value={achievedInTime[0] || 0}
        refValue={achievedInTime[1] || 0}
        loading={loading}
        popupInfo={t(
          "Son todos aquellos objetivos que se cierran dentro del plazo establecido"
        )}
      />
      <DashboardCard
        title={t("Objetivos logrados fuera de tiempo")}
        value={accomplishedOutOfTime[0]}
        refValue={accomplishedOutOfTime[1]}
        loading={loading}
        popupInfo={t(
          "Son todos aquellos objetivo que fueron cumplidos una vez que terminó el plazo establecido"
        )}
      />
      <DashboardCard
        title={t("Objetivos no logrados")}
        value={notAchieved[0]}
        refValue={notAchieved[1]}
        loading={loading}
        popupInfo={t(
          "Son todos los objetivos que a la fecha de la consulta, no han sdo cerrados o cumplidos"
        )}
      />
      <DashboardCard
        title={t("Logro de objetivos")}
        value={performance}
        percent
        loading={loading}
        popupInfo={t("Total de objetivos/ objetivos cumplidos en tiempo")}
      />
    </div>
  );
};

export default KPIOrgCareers;
